import $ from 'jquery';

$(() => {
  $('ul,ol', '.js-handle-list, .gds3-wrapper').addClass('fil-list');
});
